import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import YourRequest from "./YourRequest";
import RequestHistory from "./RequestHistory";

const Index: React.FC = () => {
  const [showHistory, setShowHistory] = useState(false);
  const location = useLocation();

  // History is a local-state view within /my-loads. Clicking the "Your Requests"
  // sidebar link re-navigates to the same path (new location.key) but doesn't
  // remount this component, so reset back to the requests view on navigation —
  // otherwise the History view stays stuck. The in-page History button flips the
  // state without navigating, so it isn't affected.
  useEffect(() => {
    setShowHistory(false);
  }, [location.key]);

  return (
    <div>
      {showHistory ? (
        <RequestHistory onBack={() => setShowHistory(false)} />
      ) : (
        <YourRequest onShowHistory={() => setShowHistory(true)} />
      )}
    </div>
  );
};

export default Index;
